import { apiWobaBackend } from "@/services/api-woba-backend";
import { AxiosError } from "axios";
import { UpdatePoBookingParams } from "./update-po-bookings.types";

export const UpdatePoBookingApi = async (params: UpdatePoBookingParams) => {
  try {
    const response = await apiWobaBackend.patch(
      `/private-offices/contracts/${params.contractId}/bookings/${params.bookingId}`,
      {
        takePercentage: params.take,
        monthlyCredits: params.credits,
        payout: params.transfer,
      },
    );

    return { success: true, data: response.data };
  } catch (error) {
    const errorData = error as AxiosError<{ message: string }>;
    const errorMessage = errorData.response?.data;

    return {
      success: false,
      error: errorMessage?.message || "Erro ao atualizar booking",
    };
  }
};
